import Module from "./Module"
import RekeningBank from "./views/RekeningBank";
import RekeningBankCreate from "./views/RekeningBankCreate";
import RekeningBankDetail from "./views/RekeningBankDetail";
import RekeningBankRiwayatTransfer from "./views/RekeningBankRiwayatTransfer";
import RekeningBankDetailSetoran from "./views/RekeningBankDetailSetoran";
import RekeningBankTransferKas from "./views/RekeningBankTransferKas";

const requireAuth = {requireAuth: true}

const moduleRoute = {
	path: '/rekening-bank',
	component: Module,
	children: [
		{
			path: '',
			name: "RekeningBank.List",
			component: RekeningBank,
			meta: {
				...requireAuth,
				accessKey: 'accountNumberAndEdc.bank',
			},
		},
		{
			path: 'create',
			name: "RekeningBank.Create",
			component: RekeningBankCreate,
			meta: {
				...requireAuth,
				accessKey:'bank.create'
			}
		},
		{
			path: 'detail/:id',
			name: "RekeningBank.Detail",
			component: RekeningBankDetail,
			meta: {
				...requireAuth,
				accessKey: 'bank.read'
			}
		},
		{
			path: "ubah-nama",
			name: "RekeningBank.UbahNama",
			components: {
				default: RekeningBankDetail,
				dialog: () => import("./views/modal/RekeningBankModalUbahNamaRekening"),
			},
			meta: {
				...requireAuth,
				accessKey: 'bank.update'
			}
		},
		{
			path: "ubah-norek",
			name: "RekeningBank.UbahNorek",
			components: {
				default: RekeningBankDetail,
				dialog: () => import("./views/modal/RekeningBankModalUbahNomorRekening"),
			},
			meta: {
				...requireAuth,
				accessKey: 'bank.update'
			}
		},
		{
			path: "ubah-keterangan",
			name: "RekeningBank.UbahKeterangan",
			components: {
				default: RekeningBankDetail,
				dialog: () => import("./views/modal/RekeningBankModalUbahKeteranganRekening"),
			},
			meta: {
				...requireAuth,
				accessKey: 'bank.update'
			}
		},
		{
			path: "delete",
			name: "RekeningBank.Delete",
			components: {
				default: RekeningBankDetail,
				dialog: () => import("./views/modal/RekeningBankModalHapus"),
			},
			meta: {
				...requireAuth,
				accessKey: 'bank.delete'
			}
		},
		{
			path: "riwayat-transfer/:id",
			name: "RekeningBank.RiwayatTransfer",
			component: RekeningBankRiwayatTransfer,
			meta: {
				...requireAuth,
				accessKey: 'bank.read'
			}
			
		},
		{
			path: "detail-setoran/:ref_type/:ref_id",
			name: "RekeningBank.DetailSetoran",
			component: RekeningBankDetailSetoran,
			meta: {
				...requireAuth,
				accessKey: 'bank.read'
			}
		},
		{
			path: "transfer-kas-bank/:id",
			name: "RekeningBank.TransferKasBank",
			component: RekeningBankTransferKas,
			meta: {
				...requireAuth,
				accessKey: 'bank.transfer'
			}
		},
	]
}

export default router => {
	router.addRoutes([moduleRoute])
}